import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "groupKey", "onClick", "scrollTarget"];
import { Button } from 'foundations-components/transitional/components/Button';
import { useTabNavigationTarget, useSetSelectedView } from '../../../hooks/viewCta';
import { jsx as _jsx } from "react/jsx-runtime";
const TabNavigationButton = _ref => {
  let {
      children,
      groupKey,
      onClick
    } = _ref,
    remainingButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const navigationTarget = useTabNavigationTarget(groupKey);
  const setSelectedView = useSetSelectedView();
  return /*#__PURE__*/_jsx(Button, Object.assign({
    onClick: event => {
      if (onClick) {
        onClick(event);
      }
      setSelectedView(navigationTarget);
    }
  }, remainingButtonProps, {
    children: children
  }));
};
export default TabNavigationButton;